function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Helper methods used by GPUGridAggregator.
import GL from 'luma.gl/constants';
import { Buffer, Framebuffer, Texture2D } from 'luma.gl';
export function getFloatTexture(gl, opts) {
  var _parameters;

  var _opts$width = opts.width,
      width = _opts$width === void 0 ? 1 : _opts$width,
      _opts$height = opts.height,
      height = _opts$height === void 0 ? 1 : _opts$height;
  var texture = new Texture2D(gl, {
    data: null,
    format: GL.RGBA32F,
    type: GL.FLOAT,
    border: 0,
    mipmaps: false,
    parameters: (_parameters = {}, _defineProperty(_parameters, GL.TEXTURE_MAG_FILTER, GL.NEAREST), _defineProperty(_parameters, GL.TEXTURE_MIN_FILTER, GL.NEAREST), _parameters),
    dataFormat: GL.RGBA,
    width: width,
    height: height
  });
  return texture;
}
export function getFramebuffer(gl, opts) {
  var id = opts.id,
      _opts$width2 = opts.width,
      width = _opts$width2 === void 0 ? 1 : _opts$width2,
      _opts$height2 = opts.height,
      height = _opts$height2 === void 0 ? 1 : _opts$height2;
  var texture = opts.texture || getFloatTexture(gl, opts);
  var fb = new Framebuffer(gl, {
    id: id,
    width: width,
    height: height,
    attachments: _defineProperty({}, GL.COLOR_ATTACHMENT0, texture)
  });
  return fb;
}
export function getFloatArray(array, size) {
  var fillValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (!array || array.length < size) {
    return new Float32Array(size).fill(fillValue);
  }

  return array;
}
export function updateBuffer(_ref) {
  var gl = _ref.gl,
      bufferName = _ref.bufferName,
      data = _ref.data,
      result = _ref.result;

  if (result[bufferName]) {
    result[bufferName].subData({
      data: data
    });
  } else {
    result[bufferName] = new Buffer(gl, data);
  }
}
//# sourceMappingURL=gpu-grid-aggregator-utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@deck.gl/core/dist/esm/experimental/utils/gpu-grid-aggregation/gpu-grid-aggregator-utils.js
// module id = 896
// module chunks = 0